import { render, staticRenderFns } from "./ArticleLayout.vue?vue&type=template&id=19f35dfe&"
import script from "./ArticleLayout.vue?vue&type=script&lang=js&"
export * from "./ArticleLayout.vue?vue&type=script&lang=js&"
import style0 from "./ArticleLayout.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports